import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export class NameService {
  constructor(client, registry) {
    _defineProperty(this, "client", void 0);
    _defineProperty(this, "registry", void 0);
    this.client = client;
    this.registry = registry;
  }
  async resolveName(address) {
    try {
      const {
        contract,
        getQueryMsg
      } = this.registry;
      const result = await this.client.queryContractSmart(contract, getQueryMsg(address));
      return result;
    } catch (e) {
      console?.error(e);
      return undefined;
    }
  }
}